<template>
  <div class="d-exit-modal modal modal-sm sign-up-modal">
    <div class="overlay" />
    <div class="modal-content">
      <div class="modal-image">
        <slot name="modal-image" />
      </div>
      <div class="modal-body">
        <slot name="modal-pre-body" />

        <a
          class="button button-icon button-close button-close-modal"
          @click="hideModal($event)"
        />

        <slot name="modal-body" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  methods: {
    hideModal(event) {
      Vue.prototype.modalHandler.hideFromButton(event);
    },
  },
};
</script>
